<template>
  <div>
    <NavigationBreadcrumb :items="breadcrumb_items"></NavigationBreadcrumb>
    <div>
      <h3 class="mb-2 mt-3">
        {{
          $getVisibleNames(
            "mesh.egressprofiletype",
            true,
            "Tipos de Perfiles de Egreso"
          )
        }}
        <AlternativeNameButton
          :table_name="'mesh.egressprofiletype'"
          :allows_crud="allows_crud"
        ></AlternativeNameButton>
      </h3>
      <div style="display: flex">
        <div class="col" style="text-align: left">
          <ButtonMedium
            v-can="'mesh.add_egressprofiletype'"
            v-if="allows_crud"
            :tooltip_text="
              $t('reusable.common.addTooltip', {
                entity: $getVisibleNames(
                  'mesh.egressprofiletype',
                  false,
                  'Tipo de Perfil de Egreso'
                ),
              })
            "
            :text_button="$t('reusable.common.add')"
            :click_button="() => $bvModal.show(`new-egress-profile-type-modal`)"
            :icon="'plus'"
            :variant="'primary'"
          >
          </ButtonMedium>
          <!-- Tipo de Perfil de Egreso -->
        </div>
      </div>
      <GenericBTable
        v-if="searchEgressProfileType.length > 0"
        class="egress-profile-type-table"
        :items="egress_profile_types"
        :pagination="egress_profile_types.length"
        :fields="egressProfileTypesFields"
        :filter="input_search"
        :show_pagination="true"
        :search_filter="true"
        :columns_display="true"
        :allows_crud="allows_crud"
        :display_id="display_id"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
      >
        <template v-if="allows_crud" #cell(actions)="row">
          <ButtonSmall
            :tooltip_text="
              $t('reusable.common.editTooltip', {
                entity: $getVisibleNames(
                  'mesh.egressprofiletype',
                  false,
                  'Tipo de Perfil de Egreso'
                ),
              })
            "
            :click_button="
              () =>
                $bvModal.show(`edit-egress-profile-type-modal-${row.item.id}`)
            "
            :class="`mr-1`"
            :icon="'square'"
          ></ButtonSmall>
          <ButtonSmall
            v-if="isValidDelete(row.item.id)"
            :click_button="() => askForDeleteEgressProfileType(row.item.id)"
            :tooltip_text="
              $t('reusable.common.deleteTooltip', {
                entity: $getVisibleNames(
                  'mesh.egressprofiletype',
                  false,
                  'Tipo de Perfil de Egreso'
                ),
              })
            "
            :icon="'trash'"
          ></ButtonSmall>
          <span
            v-else
            v-b-tooltip.v-secondary.auto.noninteractive="
              $t(
                'curricularDefinitions.egressProfileType.cannotDeleteWithEntity',
                {
                  entity1: $getVisibleNames(
                    'mesh.egressprofiletype',
                    false,
                    'Tipo de Perfil de Egreso'
                  ),
                  entity2: $getVisibleNames('mesh.career', true, 'Programas'),
                }
              )
            "
          >
            <ButtonSmall
              :tooltip_text="``"
              :disabled_button="true"
              :icon="'trash'"
            ></ButtonSmall>
          </span>
          <b-modal
            :id="`edit-egress-profile-type-modal-${row.item.id}`"
            :title="
              $t('reusable.common.editModalTitle', {
                entity: $getVisibleNames(
                  'mesh.egressprofiletype',
                  false,
                  'Tipo de Perfil de Egreso'
                ),
              })
            "
            size="md"
            hide-footer
          >
            <EgressProfileTypeForm
              :EgressProfileType="row.item"
              @updated="slotUpdatedEgressProfileType"
              :show_title="false"
            ></EgressProfileTypeForm>
          </b-modal>
        </template>
      </GenericBTable>
      <div v-else>
        <br />
        <!-- tipo de Perfil de Egreso -->
        <strong
          >{{ $t("reusable.common.noDataFound") }}
          {{
            $getVisibleNames(
              "mesh.egressprofiletype",
              false,
              "Tipo de Perfil de Egreso"
            )
          }}.</strong
        >
      </div>
    </div>
    <b-modal
      :id="`new-egress-profile-type-modal`"
      :hide-footer="true"
      :title="
        $t('reusable.common.createModalTitle', {
          entity: $getVisibleNames(
            'mesh.egressprofiletype',
            false,
            'Tipo de Perfil de Egreso'
          ),
        })
      "
      size="md"
    >
      <EgressProfileTypeForm
        v-if="institution"
        @created="slotCreatedEgressProfileType"
        :default_module_minutes="institution.module_minutes"
        :show_title="false"
      ></EgressProfileTypeForm>
    </b-modal>
  </div>
</template>

<script>
import * as names from "@/store/names";
import { mapGetters } from "vuex";
import { toast } from "@/utils/utils";

export default {
  name: "EgressProfileTypeView",
  components: {
    EgressProfileTypeForm: () =>
      import(
        "@/components/mesh/EgressProfile/EgressProfileType/EgressProfileTypeForm"
      ),
    GenericBTable: () => import("@/components/reusable/GenericBTable"),
    AlternativeNameButton: () =>
      import("@/components/reusable/AlternativeNameButton"),
    ButtonSmall: () =>
      import("@/components/reusable/Buttons/Small/ButtonSmall"),
    ButtonMedium: () =>
      import("@/components/reusable/Buttons/Medium/ButtonMedium"),
    NavigationBreadcrumb: () =>
      import("@/components/reusable/NavigationBreadcrumb"),
  },
  props: {
    input_search: {
      type: String,
      default: "",
    },
    display_id: {},
  },
  data() {
    return {
      sortBy: "",
      sortDesc: false,
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      institution: "getInstitution",
      egress_profile_types: names.PROFILE_TYPES,
      egressProfiles: names.EGRESS_PROFILES,
    }),
    breadcrumb_items() {
      return [
        { text: this.$t("reusable.breadcrumb.home"), to: "/home" },
        {
          text: this.$getVisibleNames(
            "mesh.egressprofiletype",
            true,
            "Tipos de Perfiles de Egreso"
          ),
        },
      ];
    },
    allows_crud() {
      const has_permission = this.$hasPermissions("mesh.add_egressprofiletype");
      if (has_permission) return has_permission;
      else return false;
    },
    searchEgressProfileType: function () {
      return this.egress_profile_types
        .filter((item) => {
          return (
            item.name.toLowerCase().includes(this.input_search.toLowerCase()) ||
            item.module_minutes == this.input_search
          );
        })
        .sort(function (a, b) {
          return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
        });
    },
    egressProfileTypesFields() {
      if (!this.allows_crud)
        return this.egress_profile_types_fields.filter(
          (field) => !field.requires_allows_crud
        );
      else return this.egress_profile_types_fields;
    },
    egress_profile_types_fields() {
      return [
        {
          key: "name",
          label: String(
            this.$getVisibleNames(
              "mesh.egressprofiletype",
              true,
              "Tipos de Perfiles de Egreso"
            )
          ),
          tdClass: "text-left",
          sortable: true,
          display_column: true,
        },
        {
          key: "module_minutes",
          label: this.$t(
            "curricularDefinitions.egressProfileType.minutesPerPedagogicalHour"
          ),
          sortable: true,
          display_column: true,
        },
        {
          key: "actions",
          label: "",
          display_column: true,
          thClass: "noprint",
          tdClass: "noprint",
        },
      ];
    },
  },
  methods: {
    isValidDelete(egress_profile_type_id) {
      const list = this.egressProfiles.filter(
        (x) => x.egress_profile_type == egress_profile_type_id
      );
      if (list.length > 0) return false;
      else return true;
    },
    askForDeleteEgressProfileType(egress_profile_type_id) {
      this.$swal({
        title: this.$t(
          "curricularDefinitions.egressProfileType.deleteConfirmTitle"
        ),
        text: this.$t("reusable.common.deleteConfirmText"),
        type: "warning",
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch(names.DELETE_PROFILE_TYPE, egress_profile_type_id)
            .then(() => {
              toast(
                this.$t(
                  "curricularDefinitions.egressProfileType.deletedMessage"
                )
              );
            });
        }
      });
    },
    slotCreatedEgressProfileType() {
      this.$bvModal.hide("new-egress-profile-type-modal");
    },
    slotUpdatedEgressProfileType(egress_profile_type) {
      this.$bvModal.hide(
        `edit-egress-profile-type-modal-${egress_profile_type.id}`
      );
    },
  },
  mounted() {},
  created() {
    this.$store.dispatch(names.FETCH_EGRESS_PROFILES);
    this.$store.dispatch(names.FETCH_PROFILE_TYPES);
  },
};
</script>
<style scoped>
.td-actions {
  max-width: 100px !important;
}
.title-header {
  padding: 0 1rem;
  margin-top: auto;
}
.search-egress-profile-type {
  max-width: 50rem;
  margin-left: auto;
  margin-right: 18.5%;
  margin-bottom: 1rem;
  margin-top: 0.5rem;
}
.edit-section {
  margin-top: -2%;
}
</style>